module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLicenceHistory),
      expression: "showLicenceHistory"
    }],
    attrs: {
      "id": "historyDetail"
    }
  }, [_c('modal', {
    attrs: {
      "transition": "modal fade",
      "title": "Licence History",
      "large": "",
      "force": ""
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "licenceHistoryForm"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('datatable', {
    ref: "licence_history_table",
    attrs: {
      "id": "licence-history-table",
      "dtOptions": _vm.dtOptionsLicenceHistory,
      "dtHeaders": _vm.dtHeadersLicenceHistory
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b57cb84"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/licence_history_modal.vue
// module id = 1020
// module chunks = 0